import { useState, useEffect, useCallback } from 'react';
import * as nodesApi from '../api/nodes';

export function useNodes() {
  const [nodes, setNodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadNodes = useCallback(async (search = '') => {
    try {
      setLoading(true);
      setError(null);
      const data = await nodesApi.fetchNodes(search);
      setNodes(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const addNode = useCallback(async (nodeData) => {
    const newNode = await nodesApi.createNode(nodeData);
    setNodes(prev => [newNode, ...prev]);
    return newNode;
  }, []);

  const editNode = useCallback(async (id, updates) => {
    const updatedNode = await nodesApi.updateNode(id, updates);
    setNodes(prev => prev.map(node =>
      node.id === id ? updatedNode : node
    ));
    return updatedNode;
  }, []);

  const removeNode = useCallback(async (id) => {
    await nodesApi.deleteNode(id);
    setNodes(prev => prev.filter(node => node.id !== id));
  }, []);

  const removeAllNodes = useCallback(async () => {
    await nodesApi.deleteAllNodes();
    setNodes([]);
  }, []);

  const importNodesFromArray = useCallback(async (nodesArray) => {
    const result = await nodesApi.importNodes(nodesArray);
    await loadNodes(); // Reload all nodes
    return result;
  }, [loadNodes]);

  const importFromFile = useCallback(async (file) => {
    const result = await nodesApi.importNodesFromFile(file);
    await loadNodes(); // Reload all nodes
    return result;
  }, [loadNodes]);

  useEffect(() => {
    loadNodes();
  }, [loadNodes]);

  return {
    nodes,
    loading,
    error,
    loadNodes,
    addNode,
    editNode,
    removeNode,
    removeAllNodes,
    importNodesFromArray,
    importFromFile
  };
}
